import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Login from '../Login';

export default function LandingPage() {
  const { isAuthenticated, isLoading } = useAuth0();

  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      const params = new URLSearchParams(window.location.search);
      // During the Auth0 redirect callback (?code=&state=), Auth0's
      // onRedirectCallback handles navigation via appState.returnTo — don't
      // race it. Otherwise (an already-signed-in user hitting "/") honor an
      // explicit returnTo, defaulting to the dashboard.
      if (params.has('code') && params.has('state')) return;
      navigate(params.get('returnTo') || '/dashboard');
    }
  }, [isAuthenticated]);

  if (!isAuthenticated && !isLoading) {
    return <Login />;
  }

  return <></>;
}
